import { Box, Container, Typography } from "@mui/material";

const Image = ({ src, alt, style }: any) => <Box component="img" src={src} alt={alt} style={style} loading="lazy" />;

const getRandomPosition = () => ({
  left: `${Math.random() * 100}vw`,
  top: `${Math.random() * 100}vh`,
});

const Fantastic = () => {
  return (
    <Container
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#756DE9",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 10,
          left: 10,
          width: 77,
          height: 40,
        }}
      >
        <Image src="/images/Seevi-Logo-White.png" alt="Seevi Logo" style={{ width: 77, height: 40 }} />
      </Box>

      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 30,
        }}
      >
        <Image src="/images/Clap4.png" alt="Image 1" style={{ width: 138.55, height: 285.33 }} />
      </Box>
      <Box
        sx={{
          position: "absolute",
          left: 0,
          bottom: 0,
        }}
      >
        <Image src="/images/Page-1.png" alt="Image 2" style={{ width: 170.7, height: 292.59 }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-10.png" alt="Image 1" style={{ width: "10px", height: "10px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-15.png" alt="Image 2" style={{ width: "10px", height: "10px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-16.png" alt="Image 3" style={{ width: "12px", height: "12px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-20.png" alt="Image 4" style={{ width: "8px", height: "8px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-21.png" alt="Image 5" style={{ width: "9px", height: "9px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-22.png" alt="Image 6" style={{ width: "6px", height: "6px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-23.png" alt="Image 7" style={{ width: "8px", height: "8px" }} />
      </Box>
      <Box>
        <Typography variant="h4" align="center" sx={{ color: "white", fontWeight: "6  00", fontSize: "30px" }}>
          Fantastic!
        </Typography>
        <Typography variant="h6" align="center" sx={{ color: "white", fontWeight: "medium", mt: 2, fontSize: "18px" }}>
          120 opportunities for your role are waiting for you!
        </Typography>
      </Box>
    </Container>
  );
};

export default Fantastic;
